import React, { HTMLAttributes } from 'react';
import Helmet from 'react-helmet';
import Immutable from 'immutable';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphFAQ as ParagraphFaqType } from '../../../types/uncinc_profile/paragraphs';
import { WysiwygField } from '../../../components';

interface ParagraphFAQProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphFaqType>;
}

const ParagraphFAQ: React.FC<ParagraphFAQProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.value;
  const nodes = paragraph.field_faq.map((field) => field.entity);

  const schema = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: nodes.map((node) => ({
      '@type': 'Question',
      name: node.title[0].value,
      acceptedAnswer: {
        '@type': 'Answer',
        text: node.body[0].processed,
      },
    })),
  });

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {schema}
        </script>
      </Helmet>

      <div id={uuid} className="ParagraphFAQ">
        <Container>
          {title && <h2>{title}</h2>}
          {body && <WysiwygField html={body} />}
          {nodes.map((node) => {
            const nodeId = node.nid[0].value;
            const langcode = node.langcode[0].value;

            return (
              <Node
                key={`node:${nodeId}:${langcode}`}
                id={nodeId}
                entity={Immutable.fromJS(node)}
              />
            );
          })}
        </Container>
      </div>
    </>
  );
};

export default ParagraphFAQ;
